import { useSelector } from 'react-redux';
import { selectSong } from 'services/store/newSongs/selectors';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { SongActionButtons } from 'components';
import { ActionButtonsContainer } from './styled';

type PropsType = {
  songId: string;
};

const ActionButtonsSection = ({ songId }: PropsType) => {
  const song = useSelector(selectSong(songId));

  if (!song) {
    return null;
  }
  return (
    <ActionButtonsContainer>
      <SongActionButtons
        song={song}
        location={AnalyticsEventLocation.MINI_AUDIO_PLAYER}
      />
    </ActionButtonsContainer>
  );
};

export default ActionButtonsSection;
